import { Alert, Button, Col, Divider, Input, Row, Space } from 'antd';
import { StyledPromotionCode } from './PromotionCode.styled';
import usePromotionCode from './usePromotionCode.hook';

export default function PromotionCode({
  promotionCode,
  setPromotionCode,
  total,
  totalWithoutDiscount,
}) {
  const { state, actions } = usePromotionCode({ setPromotionCode });
  return (
    <StyledPromotionCode>
      {state.opened || promotionCode ? (
        <div className="promotion-code-wrapper">
          <div className="promotion-code-row">
            <Input
              className="promotion-code-input"
              value={state.promotionCode || promotionCode?.code}
              placeholder="Coupon"
              onChange={(event) =>
                actions.setState({ promotionCode: event.target.value })
              }
              disabled={promotionCode}
            />
            <Space>
              {promotionCode ? (
                <Button onClick={actions.removePromotionCode}>Remove</Button>
              ) : (
                <>
                  <Button
                    type="primary"
                    loading={state.loading}
                    disabled={state.loading || !state.promotionCode}
                    onClick={actions.checkPromotionCode}
                  >
                    Apply
                  </Button>
                  <Button onClick={() => actions.setOpened(false)}>
                    Close
                  </Button>
                </>
              )}
            </Space>
          </div>
          {promotionCode && (
            <Row justify="end">
              <Col span={24} className="promotion-code-text mt">
                <Space className="big">
                  <strong>{promotionCode.label}</strong>
                  <span>coupon applied</span>
                </Space>
              </Col>
              <Col span={24} className="promotion-code-totals">
                <div>
                  Total to pay without discount:{' '}
                  <strong>${totalWithoutDiscount}</strong>
                </div>

                <div>
                  Coupon: -
                  <strong>{getPromotionCodeMessage(promotionCode)}</strong>
                </div>
                <Divider />
                <div>
                  Total to pay now: <strong>${total}</strong>
                </div>
              </Col>
            </Row>
          )}
          {state.error && (
            <Row justify="end" className="promotion-code-row">
              <Col>
                <Alert message={state.error} type="error" closable />
              </Col>
            </Row>
          )}
        </div>
      ) : (
        <Row justify="end" className="promotion-code-row">
          <Button type="link" onClick={() => actions.setOpened(true)}>
            Do you have a coupon?
          </Button>
        </Row>
      )}
    </StyledPromotionCode>
  );
}

function getPromotionCodeMessage({ type, value }) {
  return `${type == 'amount' ? '$' : ''}${value}${
    type == 'percent' ? '%' : ''
  }`;
}
